"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableIsTableOverlapHistoryItem = exports.TableTableRowAlignmentHistoryItem = exports.TableShadingInfoHistoryItem = exports.TableLookTypesHistoryItem = exports.TableLayoutTypeHistoryItem = exports.TableAvoidDoubleBordersHistoryItem = exports.TableTableStyleRowBandSizeHistoryItem = exports.TableTableStyleColumnBandSizeHistoryItem = exports.TableBordersHistoryItem = exports.TablePreferredWidthHistoryItem = exports.TableIndentHistoryItem = exports.TableCellSpacingHistoryItem = exports.TableCellMarginsHistoryItem = exports.TablePropertiesComplexUseHistoryItemBase = exports.TablePropertiesUseHistoryItemBase = exports.TablePropertiesHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var create_table_history_item_1 = require("./create-table-history-item");
var TablePropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(TablePropertiesHistoryItemBase, _super);
    function TablePropertiesHistoryItemBase(modelManipulator, boundSubDocument, tableIndex, newValue) {
        var _this = _super.call(this, modelManipulator, boundSubDocument, tableIndex) || this;
        _this.newValue = newValue;
        return _this;
    }
    return TablePropertiesHistoryItemBase;
}(create_table_history_item_1.TableBasedHistoryItem));
exports.TablePropertiesHistoryItemBase = TablePropertiesHistoryItemBase;
var TablePropertiesUseHistoryItemBase = (function (_super) {
    tslib_1.__extends(TablePropertiesUseHistoryItemBase, _super);
    function TablePropertiesUseHistoryItemBase(modelManipulator, boundSubDocument, tableIndex, newValues, newUse) {
        var _this = _super.call(this, modelManipulator, boundSubDocument, tableIndex, newValues) || this;
        _this.newUse = newUse;
        return _this;
    }
    TablePropertiesUseHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getManipulator().setValue(this.boundSubDocument, this.tableIndex, this.newValue, this.newUse);
    };
    TablePropertiesUseHistoryItemBase.prototype.undo = function () {
        this.getManipulator().restoreValue(this.boundSubDocument, this.oldState);
    };
    TablePropertiesUseHistoryItemBase.prototype.getManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return TablePropertiesUseHistoryItemBase;
}(TablePropertiesHistoryItemBase));
exports.TablePropertiesUseHistoryItemBase = TablePropertiesUseHistoryItemBase;
var TablePropertiesComplexUseHistoryItemBase = (function (_super) {
    tslib_1.__extends(TablePropertiesComplexUseHistoryItemBase, _super);
    function TablePropertiesComplexUseHistoryItemBase(modelManipulator, boundSubDocument, tableIndex, newValues, newUses) {
        var _this = _super.call(this, modelManipulator, boundSubDocument, tableIndex, newValues) || this;
        if (newValues.length !== newUses.length)
            throw new Error("newValues.length should be equal to newUses.length");
        _this.newUses = newUses;
        return _this;
    }
    TablePropertiesComplexUseHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getManipulator().setValue(this.boundSubDocument, this.tableIndex, this.newValue, this.newUses);
    };
    TablePropertiesComplexUseHistoryItemBase.prototype.undo = function () {
        this.getManipulator().restoreValue(this.boundSubDocument, this.oldState);
    };
    TablePropertiesComplexUseHistoryItemBase.prototype.getManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return TablePropertiesComplexUseHistoryItemBase;
}(TablePropertiesHistoryItemBase));
exports.TablePropertiesComplexUseHistoryItemBase = TablePropertiesComplexUseHistoryItemBase;
var TableCellMarginsHistoryItem = (function (_super) {
    tslib_1.__extends(TableCellMarginsHistoryItem, _super);
    function TableCellMarginsHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCellMarginsHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.cellMargins;
    };
    return TableCellMarginsHistoryItem;
}(TablePropertiesComplexUseHistoryItemBase));
exports.TableCellMarginsHistoryItem = TableCellMarginsHistoryItem;
var TableCellSpacingHistoryItem = (function (_super) {
    tslib_1.__extends(TableCellSpacingHistoryItem, _super);
    function TableCellSpacingHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCellSpacingHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.cellSpacing;
    };
    return TableCellSpacingHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableCellSpacingHistoryItem = TableCellSpacingHistoryItem;
var TableIndentHistoryItem = (function (_super) {
    tslib_1.__extends(TableIndentHistoryItem, _super);
    function TableIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableIndentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.indent;
    };
    return TableIndentHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableIndentHistoryItem = TableIndentHistoryItem;
var TablePreferredWidthHistoryItem = (function (_super) {
    tslib_1.__extends(TablePreferredWidthHistoryItem, _super);
    function TablePreferredWidthHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TablePreferredWidthHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.tableProperties.preferredWidth.setValue(this.boundSubDocument, this.tableIndex, this.newValue);
    };
    TablePreferredWidthHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.tableProperties.preferredWidth.restoreValue(this.boundSubDocument, this.oldState);
    };
    return TablePreferredWidthHistoryItem;
}(TablePropertiesHistoryItemBase));
exports.TablePreferredWidthHistoryItem = TablePreferredWidthHistoryItem;
var TableBordersHistoryItem = (function (_super) {
    tslib_1.__extends(TableBordersHistoryItem, _super);
    function TableBordersHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBordersHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.borders;
    };
    return TableBordersHistoryItem;
}(TablePropertiesComplexUseHistoryItemBase));
exports.TableBordersHistoryItem = TableBordersHistoryItem;
var TableTableStyleColumnBandSizeHistoryItem = (function (_super) {
    tslib_1.__extends(TableTableStyleColumnBandSizeHistoryItem, _super);
    function TableTableStyleColumnBandSizeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableTableStyleColumnBandSizeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.tableStyleColumnBandSize;
    };
    return TableTableStyleColumnBandSizeHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableTableStyleColumnBandSizeHistoryItem = TableTableStyleColumnBandSizeHistoryItem;
var TableTableStyleRowBandSizeHistoryItem = (function (_super) {
    tslib_1.__extends(TableTableStyleRowBandSizeHistoryItem, _super);
    function TableTableStyleRowBandSizeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableTableStyleRowBandSizeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.tableStyleRowBandSize;
    };
    return TableTableStyleRowBandSizeHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableTableStyleRowBandSizeHistoryItem = TableTableStyleRowBandSizeHistoryItem;
var TableAvoidDoubleBordersHistoryItem = (function (_super) {
    tslib_1.__extends(TableAvoidDoubleBordersHistoryItem, _super);
    function TableAvoidDoubleBordersHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableAvoidDoubleBordersHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.avoidDoubleBorders;
    };
    return TableAvoidDoubleBordersHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableAvoidDoubleBordersHistoryItem = TableAvoidDoubleBordersHistoryItem;
var TableLayoutTypeHistoryItem = (function (_super) {
    tslib_1.__extends(TableLayoutTypeHistoryItem, _super);
    function TableLayoutTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableLayoutTypeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.layoutType;
    };
    return TableLayoutTypeHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableLayoutTypeHistoryItem = TableLayoutTypeHistoryItem;
var TableLookTypesHistoryItem = (function (_super) {
    tslib_1.__extends(TableLookTypesHistoryItem, _super);
    function TableLookTypesHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableLookTypesHistoryItem.prototype.redo = function () {
        this.oldState = this.modelManipulator.table.tableProperties.lookTypes.setValue(this.boundSubDocument, this.tableIndex, this.newValue);
        this.modelManipulator.table.resetParagraphCharacterMergedProperties(this.boundSubDocument, this.tableIndex);
    };
    TableLookTypesHistoryItem.prototype.undo = function () {
        this.modelManipulator.table.tableProperties.lookTypes.restoreValue(this.boundSubDocument, this.oldState);
        this.modelManipulator.table.resetParagraphCharacterMergedProperties(this.boundSubDocument, this.tableIndex);
    };
    return TableLookTypesHistoryItem;
}(TablePropertiesHistoryItemBase));
exports.TableLookTypesHistoryItem = TableLookTypesHistoryItem;
var TableShadingInfoHistoryItem = (function (_super) {
    tslib_1.__extends(TableShadingInfoHistoryItem, _super);
    function TableShadingInfoHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableShadingInfoHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.shadingInfo;
    };
    return TableShadingInfoHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableShadingInfoHistoryItem = TableShadingInfoHistoryItem;
var TableTableRowAlignmentHistoryItem = (function (_super) {
    tslib_1.__extends(TableTableRowAlignmentHistoryItem, _super);
    function TableTableRowAlignmentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableTableRowAlignmentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.tableRowAlignment;
    };
    return TableTableRowAlignmentHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableTableRowAlignmentHistoryItem = TableTableRowAlignmentHistoryItem;
var TableIsTableOverlapHistoryItem = (function (_super) {
    tslib_1.__extends(TableIsTableOverlapHistoryItem, _super);
    function TableIsTableOverlapHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableIsTableOverlapHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.table.tableProperties.isTableOverlap;
    };
    return TableIsTableOverlapHistoryItem;
}(TablePropertiesUseHistoryItemBase));
exports.TableIsTableOverlapHistoryItem = TableIsTableOverlapHistoryItem;
